/**
 * @desc 修改报关单附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.ExportDeclarationExportFileRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/updateExportDeclarationFile`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
